import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  
  connect() {
    this.clicked = false
  }
  
  preventDoubleClick(event) {
    if (this.clicked) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
    
    this.clicked = true
    
    // Disable button visually
    this.element.style.opacity = '0.5'
    this.element.style.pointerEvents = 'none'
    
    // Re-enable after 3 seconds as fallback
    setTimeout(() => {
      this.clicked = false
      this.element.style.opacity = '1'
      this.element.style.pointerEvents = 'auto'
    }, 3000)
  }
}
